import { FETCH_EASYPOST_TRACKING_SUCCESS, FETCH_EASYPOST_TRACKING_REQUEST, FETCH_EASYPOST_TRACKING_FAILURE, FETCH_EASYPOST_TRACKING_REST } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getEasyPostTrackingReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_EASYPOST_TRACKING_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case FETCH_EASYPOST_TRACKING_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case FETCH_EASYPOST_TRACKING_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case FETCH_EASYPOST_TRACKING_REST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        default:
            return state;
    }
};
export default getEasyPostTrackingReducer;
